export const DATA_TEST_IDS = {
  projectCardName: 'project-card-name',
};

export const RQ_PROJECTS_KEY = ['projects'];
export const PROJECTS_LIMIT = 24;
export const LS_SPLIT_SEGMENT_MODAL_DISABLED = 'splitSegmentModalDisabled';
export const MAX_TTS_RATING = 5;

export const FOLDERS_LIMIT = {
  mobile: 4,
  laptop: 6,
  desktop: 8,
  largeDesktop: 12,
};
